import React, {Component} from 'react';
import UpdateSuccess from 'apa/components/UpdateSuccess';
import {connect} from 'react-redux';

@connect(
    state => ({
        messageList: state.apa.messageList
    })
)
export default class AlertList extends Component {

    render() {
        const {messageList} = this.props;
        return <div className='apa-alert-list'>
            {
                messageList.map(
                    (message, index) => (<UpdateSuccess key={`apa-alert-${index}`} message={message}/>)
                )
            }
        </div>
    }
}
